import React from 'react';

import SvgIcon from './SvgIcon';

const Bin = props => (
    <SvgIcon viewBox="0 0 24 25" {...props}>
        <path
            d="M19.688 3.75L18.6 21.413a1.875 1.875 0 01-1.838 1.837H7.239A1.875 1.875 0 015.4 21.413L4.312 3.75m-2.062 0h19.5-19.5zm6 0V2.212A1.462 1.462 0 019.713.75h4.575a1.463 1.463 0 011.462 1.462V3.75h-7.5zM15.75 6.75L15 20.25m-3-13.5v13.5-13.5zm-3.75 0L9 20.25l-.75-13.5z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Bin.displayName = 'BinIcon';

export default Bin;
